import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Row, Col } from 'antd';
import { Filter } from './Filter';
import { Footer } from './Footer';
import { Header } from '@/components/Settings/DataExtraction/ExtractionType/Hierarchy/Steps/Header';
import { ReportsAlreadyCreatedForm } from './Form';
import { ActionPlanSection } from './List/components';
import { useDataExtractionReport } from '@/context/DataExtractionReport';
import { StepsContainer } from '../../../styles';

export function ReportsAlreadyCreated() {
	const { gutterLayout } = useDataExtractionReport();

	return (
		<Row gutter={gutterLayout}>
			<Col span={24}>
				<StepsContainer>
					<Row gutter={[0, 32]} justify="space-between">
						<Col>
							<Header
								title="Reports"
								description={I18n.get(
									'Select a report category for extraction. You can proceed without including a report in the extraction if you wish.'
								)}
							/>
						</Col>
						<Col span={24}>
							<ReportsAlreadyCreatedForm />
						</Col>
						<Col span={24}>
							<Filter />
						</Col>
						<Col span={24}>
							<ActionPlanSection />
						</Col>
					</Row>
				</StepsContainer>
			</Col>
			<Col span={24}>
				<Footer />
			</Col>
		</Row>
	);
}
